export default {
  error: {
    type_mismatch: '型の不一致。',
  },
  validation: {
    invalid: '無効',
    required: '必須',
  },
};
